<template>
  <div
    class="flex flex-col gap-[16px] w-full h-fit bg-white border border-grays-400 rounded py-[22px] pl-[16px] pr-[36px]"
  >
    <!-- Intro/Change station -->
    <div class="flex flex-row w-full h-fit items-center">
      <h3 class="flex-1 text-xl font-medium text-primary-700">התחנה שלנו</h3>
      <div class="flex flex-row items-center gap-[16px]">
        <!-- <div class="flex flex-row items-center gap-[4px]">
          <span class="material-symbols-rounded text-error text-base">error</span>
          <p class="text-xs text-error font-medium">Station change will be updated in the next sale</p>
        </div> -->
        <button-secondary @click="handleChangeStation">
          להחליף תחנה
        </button-secondary>
      </div>
    </div>
    <!-- My station details -->
    <div class="md:flex flex-row gap-[35px] items-end">
      <div class="flex flex-col">
        <p class="text-grays-600 text-sm font-medium">שם התחנה:</p>
        <p class="text-grays-900 font-medium text-base">
          {{ profileData.site?.name }}
        </p>
      </div>
      <div class="md:flex flex-row gap-[40px]">
        <div class="flex flex-row items-center gap-[4px] text-grays-900">
          <div
            class="flex justify-center items-center h-[20px] w-[20px] rounded-full"
          >
            <span class="material-symbols-rounded text-base">location_on</span>
          </div>
          <p class="font-medium text-base">{{ profileData.site?.street }}</p>
        </div>
        <div class="flex flex-row items-top gap-[4px] text-grays-900">
          <div
            class="flex justify-center items-center h-[20px] w-[20px] rounded-full"
          >
            <span class="material-symbols-rounded text-base mt-1"
              >assistant_navigation</span
            >
          </div>
          <p class="font-medium text-base">
            {{ profileData.site?.address_description }}
          </p>
        </div>
        <div class="flex flex-row items-center gap-[4px] text-grays-900">
          <div
            class="flex justify-center items-center h-[20px] w-[20px] rounded-full"
          >
            <span class="material-symbols-rounded text-base">
              calendar_today</span
            >
          </div>
          <p class="font-medium text-base">
            {{ findDay(profileData.site?.distribution_day) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "my-station-card",
  props: {
    profileData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      daysOfWeek: [
        "יום ראשון",
        "יום שני",
        "יום שלישי",
        "יום רביעי",
        "יום חמישי",
        "יום שישי",
        "יום שבת",
      ],
    };
  },
  methods: {
    handleChangeStation() {
      if (this.profileData.siteID) {
        this.$store.commit("findStation/setSiteID", this.profileData.siteID);
      }
      if (
        this.profileData.site &&
        this.profileData.site.lat &&
        this.profileData.site.lng
      ) {
        this.$store.commit("findStation/setCoordinates", {
          latitude: this.profileData.site.lat,
          longitude: this.profileData.site.lng,
        });
      }
      this.$router.push("/change-station");
    },
    findDay(weekNumber) {
      return this.daysOfWeek[weekNumber - 1];
    },
  },
  // mounted() {
  // 	this.$store.dispatch("findStation/updateAddress", this.profileData.site?.street )
  // }
};
</script>

<style>
</style>